import React from 'react';
export function ProblemSection() {
  return <section className="py-20 md:py-24 px-6 md:px-12 max-w-4xl mx-auto text-center" data-id="element-149">
      <h2 className="text-4xl md:text-5xl font-serif mb-8" data-id="element-150">
        The first year after school can feel unclear
        <span className="text-accent" data-id="element-151">.</span>
      </h2>
      <div className="space-y-6 text-lg md:text-xl text-ink/80 leading-relaxed" data-id="element-152">
        <p data-id="element-153">
          Many recent grads are told to polish their resume, apply online, and
          attend career fairs. But that is often not enough.
        </p>
        <p data-id="element-154">
          They need help understanding who they are, what they want, how to talk
          about themselves, and how to build real relationships that lead to
          opportunity.
        </p>
      </div>
    </section>;
}